import { render, staticRenderFns } from "./SelectSupplier.vue?vue&type=template&id=5446f5ed&"
import script from "./SelectSupplier.vue?vue&type=script&lang=ts&"
export * from "./SelectSupplier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5446f5ed')) {
      api.createRecord('5446f5ed', component.options)
    } else {
      api.reload('5446f5ed', component.options)
    }
    module.hot.accept("./SelectSupplier.vue?vue&type=template&id=5446f5ed&", function () {
      api.rerender('5446f5ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/SelectSupplier.vue"
export default component.exports